/**
 * Normalize address field from { label } object or plain string
 * Used in both createProject and editProject sagas
 * 
 * @param {Object|string} addrLine1 - Address field value (can be object or string)
 * @param {string} targetFieldName - The field name to set the normalized value to
 * @returns {string} Normalized address string
 */
export const normalizeAddressField = (addrLine1, targetFieldName = 'address_line_1') => {
  if (!addrLine1) {
    return '';
  }

  // If it's an object with a label property, use the label
  if (typeof addrLine1 === 'object' && addrLine1.label) {
    return addrLine1.label;
  }

  // If it's an object without label, try value or convert to string
  if (typeof addrLine1 === 'object') {
    return addrLine1.value || String(addrLine1);
  }

  // If it's already a string, return as-is
  return addrLine1;
};
